module.exports = __webpack_public_path__ + "img/logo.8ac60aa.svg";